import { NgModule } from '@angular/core';
import { CommonModule } from '@nano/common';
import { AlertModule } from '@nano/common/alert';
import { LayoutModule } from '@nano/common/layout';

import { MessageThreadDetailsModule } from './message-thread-details/message-thread-details.module';
import { MessageThreadListModule } from './message-thread-list/message-thread-list.module';
import { MessagesRoutingModule } from './messages-routing.module';
import { MessagesComponent } from './messages.component';
import { EmptyInboxModule } from './shared/empty-inbox/empty-inbox.module';
import { StartMessageThreadModule } from './start-message-thread/start-message-thread.module';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    StartMessageThreadModule,
    MessageThreadListModule,
    MessageThreadDetailsModule,
    MessagesRoutingModule,
    EmptyInboxModule,
    AlertModule
  ],
  declarations: [MessagesComponent],
  exports: []
})
export class MessagesModule {}
